/* istanbul ignore file */
import { css } from 'styled-components';

export const wrapper = css``;
